/**
* ArticleImageDetails Module
* 
*/

var SCM = SCM || {};

SCM.ArticleImageDetails = (function ($) {

    var _activationElement = null;

    ///   <summary>Initializes Image modal containers to initially hide all elements and open a specific
    ///   element based on state of input parameters.  In addition, it initializes click events to 
    ///   active various events such as moving between between next and previous images and closing
    ///   the modal</summary >
    ///   <param name="activationElement" type="string">Indicates which element by class name activates
    ///   opening a particular modal</param >
    ///   <param name="openImageModal" type="bool">Indicates whether the initialization code should open
    ///   a specific modal.</param >
    ///   <param name="modalItemToOpen" type="string">Indicates which modal to open based on the modal's
    ///   id. </param >
    ///   <returns type="none" />
    function _init(activationElement, openImageModal, modalItemToOpen) {
        $('.figureModalContainer').hide();
        if (openImageModal === true) {
            $('#' + modalItemToOpen).fadeToggle(200);
            _toggleBodyOverflow();
            
            _getCitation(modalItemToOpen);
        }

        _activationElement = activationElement;
        _moveModalsOutsideWidget();
        _enableHandlers();
    }

    function _moveModalsOutsideWidget() {
        var $modals = $('.figureModalContainer');
        $modals.remove();
        $('#multimediaGalleryModalWrapper').append($modals);
    }

    
    function _toggleBodyOverflow() {
        $('body').toggleClass('modalOpen');
    }

    function _enableHandlers() {
        _enableHandleOpenAndClose();
        
        _enableHandleClickFirstOrLastImage();
        _enableClickModalNavigation();
        _enableHandleClickOutsideModal();

    }
    function _disableHandlers() {
        _disableHandleOpenAndClose();
        _disableHandleClickFirstOrLastImage();
        _disableClickModalNavigation();
        _disableHandleClickOutsideModal();
    }

    //Declare this to save and access later to return focus to last active element.
    var lastActive;
    
    function _enableHandleOpenAndClose() {
        $('.' + _activationElement + ', .figureModal .close').on('click', _handleOpenAndClose);
    }
    function _disableHandleOpenAndClose() {
        $('.' + _activationElement + ', .figureModal .close').off('click', _handleOpenAndClose);
    }

    function _handleOpenAndClose(event) {
        event.preventDefault();
        event.stopPropagation();
        /* itemNum is the id of the modal element to open or close and
            * refers to a modal element in the same way the modalItemToOpen input 
            * parameter does above
            */

        var itemNum = $(this).data('item');

        $('#' + itemNum).fadeToggle(200);

        $('#' + itemNum).toggleClass('active-modal');

        _toggleBodyOverflow();

        _getCitation(itemNum);

        if ($('.active-modal').length) {
            _trapFocus();
        } else {
            lastActive.focus();
        }
   
    }

    //Store value for last active element before entering modal.
    $('.js-item-image').on('click', function () {
        lastActive = document.activeElement;
    });

    //This is called to search for the clickable elements within the active modal and prevent focus from escaping while in the modal.
    function _trapFocus() {
        
        var activeModal = document.querySelector('.active-modal .figureModal');
        var focusableEls = activeModal.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
            
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        var KEYCODE_TAB = 9;
        firstFocusableEl.focus();
        activeModal.addEventListener('keydown', function (e) {
            var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }

        });
    }
    
    
    function _getCitation(elementId) {
        var articleId = $('#' + elementId).data('articleid');

        if (!articleId) {
            return;
        }

        $.ajax({
            type: 'POST',
            url: '/Article/GetCitation',
            data: { articleID: articleId }
        })
            .done(function (result) {
                if (result) {
                    document.getElementById(elementId).getElementsByClassName('citation')[0].innerHTML = result;
                }
            })
            .fail(function (result) {
                console.error(result.message);
            });
    }

    function _enableHandleClickFirstOrLastImage() {
        $('.js-item-image').first().on('click', _handleClickFirstOrLastImage);
        $('.js-item-image').last().on('click', _handleClickFirstOrLastImage);
    }
    function _disableHandleClickFirstOrLastImage() {
        $('.js-item-image').first().off('click', _handleClickFirstOrLastImage);
        $('.js-item-image').last().off('click', _handleClickFirstOrLastImage);
    }

    function _handleClickFirstOrLastImage(event) {
        event.preventDefault();
        event.stopPropagation();

        var thisNumber = $(this).data('item');
        
        _cachePrevOrNextPage($('#' + thisNumber));
    }

    function _enableClickModalNavigation() {
        $('.js-previous-image-details, .js-next-image-details').on('click', _handleModalNavigation);
    }
    function _disableClickModalNavigation() {
        $('.js-previous-image-details, .js-next-image-details').off('click', _handleModalNavigation);
    }

    function _handleModalNavigation(event) {
        event.preventDefault();
        event.stopPropagation();

        var $this = $(this);
        var currentItemNum = $this.data('item');
        var $currentItem = $('#' + currentItemNum);
        $currentItem.removeClass('active-modal');

        var newItemNum = $this.data('new-item');
        var $newItem = $('#' + newItemNum);
        $newItem.addClass('active-modal');
        
        if (newItemNum === 'newPage') {
            var nextUrl = $this.data('url');
            var itemToOpen = $this.data('modal-open');

            _toggleBodyOverflow();

            SCM.SearchResults.doSolrSearch({
                queryString: nextUrl,
                openModal: itemToOpen
            });
        }
        else {
            _getCitation(newItemNum);
        }

        $newItem.toggle(function () { $currentItem.toggle(); });

        _cachePrevOrNextPage($newItem);
        _trapFocus();
    }

    function _cachePrevOrNextPage($newItem) {
        var $prevNewItem = $newItem.find('.js-previous-image-details');
        var $nextNewItem = $newItem.find('.js-next-image-details');

        var prevOrNextUrl = null;
        var prevOrNextItemToOpen = null;

        if ($prevNewItem.data('new-item') === 'newPage') {
            prevOrNextUrl = $prevNewItem.data('url');
            prevOrNextItemToOpen = $prevNewItem.data('modal-open');
        }

        if ($nextNewItem.data('new-item') === 'newPage') {
            prevOrNextUrl = $nextNewItem.data('url');
            prevOrNextItemToOpen = $nextNewItem.data('modal-open');
        }

        if (prevOrNextUrl) {
            SCM.SearchResults.doSolrSearch({ 
                queryString: prevOrNextUrl, 
                openModal: prevOrNextItemToOpen,
                cacheSearchWithoutUpdatingDom: true,
                currentItem: $newItem,
                functionToDoWhileAjaxLoading: _toggleEnabledPrevOrNextButton
            });
        }
    }

    // Toggles the left and right navigation buttons. Should lower the opacity and disable click events until called again.
    function _toggleEnabledPrevOrNextButton($modalItemToOpen) {
        var $navButtons = $modalItemToOpen.find('.js-previous-image-details, .js-next-image-details');
        if ($modalItemToOpen.length) {
            if ($navButtons.hasClass('disabled')) {
                $navButtons.removeClass('disabled');
                _enableHandlers();
            } else if (!$navButtons.hasClass('disabled')) {
                $navButtons.addClass('disabled');
                _disableHandlers();
            }
        }
    }

    function _enableHandleClickOutsideModal() {
        /* Close modal if user clicks outside of modal which can be determined if there are
         * no parent elements with class name figureModalContainer and the modal is open
         */
        $('.figureModalContainer').on('click', _handleClickOutsideModal);
    }

    function _disableHandleClickOutsideModal() {
        /* Close modal if user clicks outside of modal which can be determined if there are
         * no parent elements with class name figureModalContainer and the modal is open
         */
        $('.figureModalContainer').off('click', _handleClickOutsideModal);
    }

    function _handleClickOutsideModal(event) {
        $target = $(event.target);
        if (!$target.parents('.figureModalContainer:visible').length) {
            $('.figureModalContainer').hide();
            $('body').removeClass('modalOpen');
            lastActive.focus();
        }
    }

    return {
        init: _init
    };

})(jQuery);
